import axios from "axios";
import { URL } from "../constants/provider/constant";
import { returnRoleBasedOnRoleId } from "../helper/utils";

export const validServices = async () => {
  try {
    let config = {
      method: "post",
      url: URL.providercore_url + "medibuddyCentral/validServices",
      headers: {
        accesstoken: JSON.parse(localStorage.getItem("access_token")),
        accept: "application/json",
      },
      data: {},
    };

    let response = await axios(config);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const locationServiceMap = (roleName, service) => {
  roleName = roleName || returnRoleBasedOnRoleId(JSON.parse(localStorage.getItem("user_details")).roleId);
  switch (service) {
    case "LABS":
      return roleName == "insureragent" ? "/"+roleName+"/appointments/esalesqueue" : "/"+roleName+"/appointments";
    case "OFFLINE_CONSULTS":
      return "/offlineConsults/upcoming";
    case "VISION":
      return "/vision/actionPending";
    default:
      return roleName == "insureragent" ? "/"+roleName+"/appointments/esalesqueue" : "/"+roleName+"/appointments";
  }
};

export const getAccessToken = () => {
  return localStorage.getItem("access_token") ?  localStorage.getItem("access_token") : ''
 } 

 export const getUserDetails = () => {
  return localStorage.getItem('user_details') ? JSON.parse(localStorage.getItem("user_details")) : []
 } 

export const getUserAddress = () => {
  const isParent = getUserDetails().parentId;
  if (isParent) return "Master Provider";
  else {
    const address = localStorage.getItem('hosp_address') || "Address Not Available";
    return address

  }
}

  export const getUserFeatureKey = ()=>{
    const userFetaureKey = localStorage.getItem('userFeatures');
    return userFetaureKey
  }

  export const otpEnabledAttendanceProvider = ()=>{
   const isOtpEnabledAttendanceProvider = JSON.parse(localStorage.getItem("isOtpEnabledAttendanceProvider"));
   return isOtpEnabledAttendanceProvider
  }
  